import {SimpleSizeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownSizeSimple} from '@aboutyou/ui-components';
import React, {FC} from 'react';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: SimpleSizeFilterSection;
  setFilter: (filterData: {filterId: string; filterSection: string}) => void;
  resetFilter: (slug: string) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionSizeSimple: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {label, slug, sizes} = data;
  const normalizedSizes = sizes.map(({id, label}) => ({
    id: `${id}`,
    label,
  }));

  const activeSlugFilters = (activeFilters.get(slug) ?? []).filter(value =>
    normalizedSizes.map(({id}) => id).includes(value),
  );

  return (
    <FilterDropdownSizeSimple
      activeSizeIds={activeSlugFilters}
      label={label}
      onClose={() => onClose(slug, filterLabel)}
      onOpen={() => onOpen(slug, filterLabel)}
      onSizeClick={id => {
        setFilter({
          filterId: id,
          filterSection: slug,
        });
      }}
      sizes={normalizedSizes}
      onFilterReset={() => resetFilter(slug)}
    />
  );
};
